
import PropTypes from 'prop-types'
import React from 'react'
import ShowHide from './ShowHide'
import humanize from 'humanize-number'
import classnames from 'classnames'
import './Table2.css'

const Table2 = props => {
  const {
    emptyText,
    columns,
    rows,
    tableLayout = 'fixed',
    sidePadding = '14px',
    sortBy = 'name',
    sortOrder = 'desc',
    onHeaderClick = () => null,
    showSideBorders
  } = props

  return (
    <div className='Table2'>
      <table className='Table2-table' style={{ tableLayout: tableLayout }}>
        <thead className='Table2-header'>
          <tr>
            {columns.map(renderColumn)}
          </tr>
        </thead>
        <tbody className='Table2-body'>
          {rows.map(renderRow(columns))}
        </tbody>
      </table>
      <ShowHide show={!rows.length}>
        <div className='Table2-noResults'>
          {emptyText}
        </div>
      </ShowHide>
    </div>
  )

  function renderColumn (column, i) {
    const columnWidth = column.width || 'auto'
    const textAlign = column.align || 'left'

    let direction
    if (sortBy === column.name) {
      direction = sortOrder
    }

    const style = {
      padding: `0px ${sidePadding}`,
      width: columnWidth,
      textAlign: textAlign
    }

    return (
      <th key={`__table2_column_${i}`} className='Table2-column' style={style}>
        <span className='Table2-columnLabel' data-direction={direction} onClick={() => onHeaderClick(column.name)}>{column.label} </span>
      </th>
    )
  }

  function renderRow (columns) {
    return function (data, i) {
      const isClickable = typeof data.onClick === 'function'
      const classes = classnames({
        'Table2-row': true,
        'Table2-row--error': !!data.error,
        'Table2-row--showSideBorders': showSideBorders
      })
      return (
        <tr key={`__Table2_row_${i}`} className={classes} data-is-clickable={isClickable} onClick={data.onClick}>
          {columns.map(renderCell(data))}
        </tr>
      )
    }
  }

  function renderCell (cell) {
    return function (column, i) {
      const columnWidth = column.width || 'auto'
      const textAlign = column.align || 'left'
      const currentColumn = cell[column.name] || {}
      let content = currentColumn.content || currentColumn.value
      let title = currentColumn.title
      const isString = typeof content === 'string'
      if (!title && isString) title = content
      const attrs = {
        key: `__table2_cell_${i}`,
        className: classnames({ 'Table2-cell': true, 'Table2-cell--truncate': isString }),
        style: {
          padding: `14px ${sidePadding}`,
          width: columnWidth,
          textAlign: textAlign
        }
      }

      if (column.header) return <th {...attrs} title={title}>{content}</th>
      if (typeof content === 'number') content = humanize(content)
      return <td {...attrs} title={title}>{content}</td>
    }
  }
}

Table2.defaultProps = {
  onHeaderClick: () => null,
  sidePadding: '14px',
  sortBy: 'name',
  sortOrder: 'desc',
  tableLayout: 'fixed',
  showSideBorders: false
}

Table2.displayName = 'Table2'

Table2.propTypes = {
  columns: PropTypes.array.isRequired,
  emptyText: PropTypes.string,
  onHeaderClick: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired,
  sidePadding: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  tableLayout: PropTypes.string.isRequired,
  showSideBorders: PropTypes.bool
}

export default Table2



// WEBPACK FOOTER //
// ./ui/Table2.js